import type { CSSProperties } from "react"

export const DASHBOARD_WIDGET_SCROLLBAR_STYLE = {
  scrollbarColor: "rgb(203 213 225) transparent",
  scrollbarGutter: "stable",
  scrollbarWidth: "thin",
} satisfies CSSProperties
